import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { OrgListSummary } from '../../../models/organizations.model';

@Component({
	selector: 'app-org-list-modal',
	styleUrls: ['./org-list-modal.component.scss'],
	templateUrl: './org-list-modal.component.html',
})
export class OrgListModalComponent implements OnInit {
	resultIds: string[] = [];

	constructor(
		public dialogRef: MatDialogRef<OrgListModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			disabled: string;
			organizations: OrgListSummary[];
			selected: string[];
		},
	) {}

	closeModal() {
		this.dialogRef.close();
	}

	ngOnInit(): void {
		this.resultIds = this.data.selected;
	}

	onCheckboxToggle(id: string, checked: boolean): void {
		if (!checked) {
			this.resultIds.splice(
				this.resultIds.findIndex((i) => id === i),
				1,
			);
		} else {
			this.resultIds.push(id);
		}
	}

	saveItems(): void {
		const result = [];

		if (Array.isArray(this.data.organizations)) {
			for (const org of this.data.organizations) {
				if (this.resultIds.includes(org.id)) {
					result.push(org);
				}

				for (const orgS of org.secondary) {
					if (this.resultIds.includes(orgS.id)) {
						result.push(orgS);
					}
				}
			}
			this.dialogRef.close(result);
		}
	}
}
